// Shows the "we can't hear the customer" banner while the ML API reports that the
// customer's audio is not reaching us (call 1238), and hides it when it comes back.
// Returns true when the event was a customer-audio event.
export function applyCustomerAudioEvent(banner, data) {
  if (!banner) return false;
  if (data?.type === "customer_audio_lost") {
    banner.classList.remove("hidden");
    return true;
  }
  if (data?.type === "customer_audio_restored") {
    banner.classList.add("hidden");
    return true;
  }
  return false;
}
